import React from "react";
import FileUploaderHandler from "./FileUploaderHandler";
import { useDispatch } from "react-redux";
import {
  migrateChartsOfAccount,
  migrateCustomer,
  migrateCustomerClaim,
  migrateCustomerPolicyApp,
  migrateCustomerPolicyRisk,
  migrateCustomerTransaction,
  migrateJournal,
  migrateSavingsApp,
  migrateStaff,
  migrateUser,
} from "../../../redux/slice/migration/migrationSlice";

const MigrationPage = () => {
  const dispatch = useDispatch();

  const handleUserDetails = (file, formName) => {
    const formData = new FormData();

    formData.append(formName, file);
    if (formName === "staffdetails") {
      dispatch(migrateStaff(formData));
    }
    if (formName === "customerdetail") {
      dispatch(migrateCustomer(formData));
    }

    if (formName === "customerTransaction") {
      dispatch(migrateCustomerTransaction(formData));
    }

    if (formName === "customerClaim") {
      dispatch(migrateCustomerClaim(formData));
    }
    if (formName === "policyAppDetails") {
      dispatch(migrateCustomerPolicyApp(formData));
    }
    if (formName === "policyAppRisk") {
      dispatch(migrateCustomerPolicyRisk(formData));
    }
    if (formName === "journal") {
      dispatch(migrateJournal(formData));
    }
    if (formName === "accountdetail") {
      dispatch(migrateChartsOfAccount(formData));
    }
    if (formName === "saving_app_details") {
      dispatch(migrateSavingsApp(formData));
    }
  };

  // useEffect(()=>{

  // }, [isMigrated]);

  return (
    <div className='mx-auto mb-5 w-75 '>
      <h1 className='text-center mt-3'>Data Migrations</h1>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Staff details
              </h4>
              <FileUploaderHandler
                submit={(file) => handleUserDetails(file, "staffdetails")}
                // sectionTitle={"User Details"}
                label={"Staff details"}
                fileId='statdetails'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Customer details
              </h4>
              <div className='w-100'>
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "customerdetail")}
                  label={"Customer details"}
                  // sectionTitle='Customer Details'
                  fileId='customerdetail'
                />
                <FileUploaderHandler
                  submit={(file) =>
                    handleUserDetails(file, "customerTransaction")
                  }
                  label={"Customer Transaction Details"}
                  fileId='customerTransaction'
                />
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "customerClaim")}
                  label={"Customer Claim Details"}
                  fileId='customerClaim'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Customer Policy Application Details
              </h4>
              <div className='' style={{ width: "100%" }}>
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "policyAppDetails")}
                  // sectionTitle='Customer Policy Application Details'
                  label={"Customer Policy Details"}
                  fileId='policyAppDetails'
                />
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "policyAppRisk")}
                  label={"Customer Risk Covers"}
                  fileId='policyAppRisk'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Chart of Accounts
              </h4>
              <div className='' style={{ width: "100%" }}>
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "journal")}
                  label={"Journal"}
                  fileId='journal'
                />
              </div>

              <div className='' style={{ width: "100%" }}>
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "accountdetail")}
                  label={"Account"}
                  fileId='accountdetail'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row mt-5 mb-4'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body border '>
              <h4 className='fw-semibold text-primary-1 bg-whit position-absolute profile-title border'>
                Savings Application
              </h4>
              <div className='' style={{ width: "100%" }}>
                <FileUploaderHandler
                  submit={(file) => handleUserDetails(file, "saving_app_details")}
                  label={"Savings Application Details"}
                  fileId='saving_app_details'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MigrationPage;
